// DEFINE ALL CONSTANTS FOR PROJECT HERE. IF NEEDED CRETE NEW FILE IN CONSTANTS FOLDER

export const NAME = "Responsum";
export const BASE_URL = "Constant";
export const FAQ_CMS_REDUX_QUESTION_FORM_NAME = "faqCmsQuestionForm";
export const LUCIA_TENANT_NAME = "lucia";
export const FAQ_CMS_FAQS_PATH = "/faq";
export const FAQ_CMS_CONTENT_EDITOR_PATH = "/faq/content-editor";
export const FAQ_CMS_SETTINGS_PATH = "/faq/settings";

// SUBDOMAINS

export const SALES_SUBDOMAIN = "mkruzic";




// todo remove FAQ_CMS_CUSTOM_FIELDS once the settings have been migrated to Dynamo
export const FAQ_CMS_CUSTOM_FIELDS = {
  has: [
    {
      name: "airport",
      label: "Airport",
      options: [
        { value: "ALL", label: "All" },
        { value: "HOU", label: "HOU" },
        { value: "IAH", label: "IAH" },
        { value: "EFD", label: "EFD (Ellington Field)" },
        { value: "HSP", label: "HSP (Houston Spaceport)" }
      ],
      sourceFieldName: "site"
    }
  ],
  "dev-gattel+covidfaq@outlook.com": [
    {
      name: "airport",
      label: "Airport",
      options: [
        { value: "ALL", label: "All" },
        { value: "HOU", label: "HOU" },
        { value: "IAH", label: "IAH" },
        { value: "EFD", label: "EFD (Ellington Field)" },
        { value: "HSP", label: "HSP (Houston Spaceport)" }
      ],
      sourceFieldName: "site"
    }
  ],
  "dev-ssteinberg@iolap.com": [
    {
      name: "airport",
      label: "Airport",
      options: [
        { value: "ALL", label: "All" },
        { value: "HOU", label: "HOU" },
        { value: "IAH", label: "IAH" },
        { value: "EFD", label: "EFD (Ellington Field)" },
        { value: "HSP", label: "HSP (Houston Spaceport)" }
      ],
      sourceFieldName: "site" 
    }
  ]
};

export const SIDEBAR_LINKS = [
  { 
    pathname: "/dashboard", 
    name: "Dashboard", 
    disableForNonAdmin: false,
    disabledAccessApps: [],
    MuiIconName: "Dashboard"
  },
  { 
    pathname: "/assistant", 
    name: "Assistant", 
    disableForNonAdmin: false,
    disabledAccessApps: [SALES_SUBDOMAIN],
    MuiIconName: "Assistant"
  },
  { 
    pathname: "/manage-connections", 
    name: "Manage Connectors", 
    disableForNonAdmin: false,
    disabledAccessApps: [],
    MuiIconName: "Extension"
  },
  { 
    pathname: "/users", 
    name: "Manage Users", 
    disableForNonAdmin: false,
    disabledAccessApps: [],
    MuiIconName: "Person"
  },
  { 
    pathname: "/manage-subscriptions", 
    name: "Manage Subscriptions", 
    disableForNonAdmin: false,
    disabledAccessApps: [SALES_SUBDOMAIN],
    MuiIconName: "Subscriptions"
  },
  { 
    pathname: null, 
    name: "Knowledge",
    disableForNonAdmin: false,
    disabledAccessApps: [],
    MuiIconName: "Menu",
    subLinks: [
      { 
        pathname: FAQ_CMS_FAQS_PATH, 
        name: "FAQ Library",
        disableForNonAdmin: false,
        disabledAccessApps: [],
        MuiIconName: "ContactSupport"
      },
      { 
        pathname: FAQ_CMS_CONTENT_EDITOR_PATH, 
        name: "Content Editor", 
        disableForNonAdmin: true,
        disabledAccessApps: [],
        MuiIconName: "Edit"
      }
    ],
  },
  { 
    pathname: "/utterance-training", 
    name: "Utterance Training", 
    disableForNonAdmin: true,
    disabledAccessApps: [],
    MuiIconName: "SpeakerNotes"
  },
  { 
    pathname: "/action-buttons", 
    name: "Action Buttons", 
    disableForNonAdmin: true,
    disabledAccessApps: [],
    MuiIconName: "CallToAction"
  },
  { 
    pathname: null, 
    name: "Settings",
    disableForNonAdmin: true,
    disabledAccessApps: [SALES_SUBDOMAIN],
    MuiIconName: "Settings",
    subLinks: [
      { 
        pathname: "/website-assistant", 
        name: "Website Assistant",
        disableForNonAdmin: true,
        disabledAccessApps: [],
        MuiIconName: "ChatBubble"
      },
      { 
        pathname: "/bubble-settings", 
        name: "Bubble Settings", 
        disableForNonAdmin: true,
        disabledAccessApps: [],
        MuiIconName: "BubbleChart"
      },
      { 
        pathname: FAQ_CMS_SETTINGS_PATH, 
        name: "FAQ Settings", 
        disableForNonAdmin: true,
        disabledAccessApps: [],
        MuiIconName: "ContactSupport"
      }
    ],
  }
]

export const SAYT_ENDPOINT_PREFIX = {
  "dev-gattel+covidfaq@outlook.com": "sayt/generic/nasa_authors/",
  "responsumai+nasademo@gmail.com": "sayt/generic/nasa_authors/",
  "dev-ssteinberg@iolap.com": "sayt/crm/",
  "dev-stevensteinberg@gmail.com": "sayt/crm/",
  "responsumai+iolap@gmail.com": "sayt/crm/",
  "dev-tandjic@iolap.com": "sayt/crm/", 
  "dev-ilakic@iolap.com": "sayt/crm/",
  "dev-tpoljak@iolap.com": "sayt/crm/",
  "dev-jbosnjakovic@iolap.com": "sayt/crm/",
  demo: "sayt/crm/"
};
